import request from "@/utils/request";

// 登录
export function login(data: any) {
  return request({
    url: "/login",
    method: "post",
    params: data,
  });
}

export function enroll(data: any, params: any) {
  return request({
    url: "/enroll",
    method: "post",
    data: data,
    params: params,
  });
}

export function verifyCode(data: any) {
  return request({
    url: "/verifyCode",
    method: "post",
    params: data,
  });
}

export function forgetPassword(data: any) {
  return request({
    url: "/forgetPassword",
    method: "post",
    params: data,
  });
}

// 获取用户信息
export function getInfo(token: string) {
  return request({
    url: "/vue-admin-template/user/info",
    method: "get",
    params: { token },
  });
}

// 更新用户信息
export function UpdateInfo(data: any) {
  return request({
    url: "/webUser",
    method: "put",
    data: data,
  });
}
export function webUserStatus(data: any) {
  return request({
    url: "/webUserStatus",
    method: "put",
    params: data,
  });
}

// 获取用户列表
export function userList(data: any) {
  return request({
    url: "/webUserList",
    method: "get",
    params: data,
  });
}

// 注销
export function logout() {
  return request({
    url: "/vue-admin-template/user/logout",
    method: "post",
  });
}
